import React, { useState } from 'react';
import './App.css';
import HomePage from "./components/HomePage";
import ConsultantForm from "./components/consultantform";
import Layout from "./components/Layout";

function App() {
  // Simple routing system
  const [currentPage, setCurrentPage] = useState<'home' | 'form'>(
    window.location.pathname === '/consultant-form' ? 'form' : 'home'
  );

  // Update URL when page changes
  React.useEffect(() => {
    const path = currentPage === 'home' ? '/' : '/consultant-form';
    window.history.pushState({}, '', path);
  }, [currentPage]);

  // Handle browser back/forward buttons
  React.useEffect(() => {
    const handlePopState = () => {
      setCurrentPage(window.location.pathname === '/consultant-form' ? 'form' : 'home');
    };
    window.addEventListener('popstate', handlePopState);
    return () => window.removeEventListener('popstate', handlePopState);
  }, []);

  // Handle navigation from child components
  React.useEffect(() => {
    const handleNavigation = (e: Event) => {
      const customEvent = e as CustomEvent;
      if (customEvent.detail?.page === 'form') {
        setCurrentPage('form');
      } else if (customEvent.detail?.page === 'home') {
        setCurrentPage('home');
      }
    };

    window.addEventListener('navigate', handleNavigation);
    return () => window.removeEventListener('navigate', handleNavigation);
  }, []);

  return (
    <Layout>
      {currentPage === 'home' ? <HomePage /> : <ConsultantForm />}
    </Layout>
  );
}

export default App;
